// App.js
import React, { useState } from 'react';
import Header from './components/Header';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import HomeLandingCarousel from './components/HomeLandingCarousel';
import Industries from './components/Industries';
import Partners from './components/Partners';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  const [selectedTab, setSelectedTab] = useState('Software');
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const handleShowPrivacyPolicy = () => {
    setShowPrivacyPolicy(true);
    window.setTimeout(() => {
      document.getElementById('privacy')?.scrollIntoView({ behavior: 'smooth' });
    }, 0);
  };

  return (
    <div>
      <Header />
      <HomeLandingCarousel />
      <About />
      <Services initialTab={selectedTab} />
      <Industries />
      <Partners />
      <Contact />
      {showPrivacyPolicy && <PrivacyPolicy />}
      <Footer onSelectTab={setSelectedTab} onShowPrivacyPolicy={handleShowPrivacyPolicy} />
    </div>
  );
}

export default App;
